export default function ExperienceSection() {
  return (
    <section className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-6">
              <i className="ri-bar-chart-line text-sm w-4 h-4 flex items-center justify-center" />
              Experiencia y Trayectoria
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              Resultados que{' '}
              <span className="text-primary-500">Hablan por Sí Solos</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
            <div className="bg-background-100 rounded-lg p-8 text-center border border-background-200/60">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-5">
                <i className="ri-ship-line text-xl" />
              </div>
              <div className="font-heading text-4xl md:text-5xl font-bold text-primary-500 mb-2">200+</div>
              <p className="text-foreground-600 text-sm font-medium mb-2">Toneladas Importadas</p>
              <p className="text-foreground-500 text-xs leading-relaxed">
                Más de 200 toneladas de demulsificante importadas con éxito desde China a Venezuela.
              </p>
            </div>

            <div className="bg-background-100 rounded-lg p-8 text-center border border-background-200/60">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-5">
                <i className="ri-building-2-line text-xl" />
              </div>
              <div className="font-heading text-4xl md:text-5xl font-bold text-accent-500 mb-2">Diversas</div>
              <p className="text-foreground-600 text-sm font-medium mb-2">Empresas Venezolanas</p>
              <p className="text-foreground-500 text-xs leading-relaxed">
                Abastecemos a empresas que operan mediante contratos de servicio y alianzas estratégicas con PDVSA.
              </p>
            </div>

            <div className="bg-background-100 rounded-lg p-8 text-center border border-background-200/60">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mx-auto mb-5">
                <i className="ri-shield-check-line text-xl" />
              </div>
              <div className="font-heading text-4xl md:text-5xl font-bold text-secondary-500 mb-2">Altos</div>
              <p className="text-foreground-600 text-sm font-medium mb-2">Estándares de Calidad</p>
              <p className="text-foreground-500 text-xs leading-relaxed">
                Producto formulado bajo estándares internacionales en China, validado por laboratorios PDVSA en Venezuela.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}